import { RollingBanner } from '../components/RollingBanner';
import { useRollingBannerService } from '../services/useRollingBannerService';

export interface RollingBannerContainerProps {}

export const RollingBannerContainer: React.FC<React.PropsWithChildren<RollingBannerContainerProps>> = () => {
  const { is_hide, catalog_product_id, banner_list, handleClick, impressBannerUBL } = useRollingBannerService();

  if (is_hide) {
    return null;
  }

  return (
    <RollingBanner
      catalog_product_id={catalog_product_id}
      banner_list={banner_list}
      onClick={handleClick}
      impressBannerUBL={impressBannerUBL}
    />
  );
};
